import React from "react";
import { Assort } from "../../../models/Assort";
import { IoAddCircle, IoRemoveCircle } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import EAIconButton from "../../shared/Buttons/EAIconButton";
import EATooltip from "../../shared/EATooltip/EATooltip";

interface IProps {
  assort: Assort;
  onAdd: (assort: Assort) => void;
  onDelete: (assort: Assort) => void;
  qnt: number;
  disabledAdding: boolean;
  disabledDelete?: boolean;
}

const AssortCard: React.FC<IProps> = ({ assort, onAdd, onDelete, qnt, disabledAdding, disabledDelete = false }) => {
  const { t } = useTranslation();
  const cardClassName = `gdansk-sale-assort-card border ${qnt > 0 ? "active" : ""}`;
  return (
    <div className={cardClassName}>
      {assort.description && assort.description.trim().length > 0 && (
        <div className="gdansk-sale-assort-card__tooltip">
          <EATooltip content={assort.description} position="left">
            <span className="gdansk-tooltip-icon">i</span>
          </EATooltip>
        </div>
      )}
      <div className="gdansk-sale-assort-card__title">
        <h5>{assort.displayWebName}</h5>
        <h5>
          {assort.listPrice} {t("zl")}
        </h5>
      </div>
      <div className="gdansk-sale-assort-card__qnt-buttons">
        <EAIconButton
          icon={<IoRemoveCircle className="gdansk-sale-assort-card__icon" />}
          variant="icon"
          title={""}
          disabled={qnt <= 0 || disabledDelete}
          onClick={() => onDelete(assort)}
        />
        <h4>{qnt}</h4>
        <EAIconButton
          icon={<IoAddCircle className="gdansk-sale-assort-card__icon" />}
          variant="icon"
          title={""}
          onClick={() => onAdd(assort)}
          disabled={disabledAdding}
        />
      </div>
    </div>
  );
};

export default AssortCard;
